import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { OrderItem } from '../types';
import { ReactComponent as LeadingIcon } from 'app/assets/img/iconLeading.svg';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';

interface TicketInfoSectionProps {
  orderItems: OrderItem[];
}

export const TicketInfoSection: React.FC<TicketInfoSectionProps> = ({
  orderItems,
}) => {
  const translations = useSelector(selectTranslations);
  return (
    <BoxContainerCollapse>
      <StyledCollapse defaultActiveKey="">
        <CollapsePanelWrapper
          className="collapseItem"
          key={1}
          header={
            <div className="boxLeftHeaderCollapse">
              <div className="boxIcon">
                <LeadingIcon width={20} height={20} />
              </div>
              <div>
                <Title>{translations?.['b2b.txt.sunWorldParkTicket'] || 'Vé công viên Sun World'}</Title>
              </div>
            </div>
          }
        >
          <div className="boxContentCollapse">
            {orderItems.map((item, index) => (
              <React.Fragment key={index}>
                {item.tickets.map((ticket, ticketIndex) => (
                  <div key={ticketIndex} className="boxContentCombo">
                    <div className="infoCombo">
                      <div className="titleCombo">{ticket.name}</div>
                      <div className="textQuantity">
                        Số lượng vé: {ticket.quantity}
                      </div>
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </CollapsePanelWrapper>
      </StyledCollapse>
    </BoxContainerCollapse>
  );
};

const BoxContainerCollapse = styled.div`
  .collapseItem {
    border-radius: 8px !important;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    .ant-collapse-header {
      padding-right: 12px !important;
      padding-top: 0px !important;
      height: 50px;
      background: #f2f2f2;
      .ant-collapse-arrow {
        right: 10px !important;
      }
    }
  }
  .boxLeftHeaderCollapse {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .boxIcon {
    background: var(--color-gradient);
    min-height: 50px;
    height: 100%;
    min-width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .boxContentCollapse {
    background: #fff;
  }
  .boxContentCombo {
    background: #f2f2f2;
    border-radius: 8px;
    padding: 10px;
    margin: 10px;
    display: flex;
    align-items: center;
  }
  .infoCombo {
    width: 100%;
  }
  .titleCombo {
    font-size: 12px;
    font-weight: 600;
  }
  .textQuantity {
    font-size: 12px;
  }
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
